<template>
<transition name="fade">
  <div id="guide">
    <h2>{{ msg }}</h2>
    <template v-if="!loggedIn">
      <div class="paper login">
        <form @submit.prevent="getAdminAccess">
          <input id="pass" v-model="passkey" type="password" :class="{invalid: invalidPass}"/>

          <button class="floating-btn" v-if="passkey">View</button>
        </form>
        <label for="pass">Please provide the admin password to continue.</label>
      </div>
    </template>
    <template v-if="loggedIn">
      <nav class="docs">
        <button title="Previous Docs"  @click="prevDoc()">⯇</button>
        <ul class="docs-header">
          <li class="shown">admin access</li>
          <li>biomall-vue-express</li>
          <li>biomall-vue</li>
          <li>biomall-express</li>
        </ul>
        <button title="Next Docs"  @click="nextDoc()">⯈</button>
      </nav>
	<div id="video-cont" class="paper">
	<video ref="videoRef" width="100%" controls>
		<source src="/guides/admin.mp4" type="video/mp4">
		Sorry, your browser doesn't support videos!
	</video>
	</div>
      <article class="paper" v-if="activeGuide==0">
        <h2>How to add new programs to this portal?</h2>
        <div class="aside"><img src="../assets/program.gif"></div>
        <p>To add a new software click the (+) button, then provide program title, the commandline and the trailing options. Note that the user's input goes between this command and option when a user submits a job.</p>
        <p>If the program outputs a file that user can download, you must check the "outputs to file" field. However, you may need to modify the source code to accomodate custom downloads for new software.</p>
        <p>You may also want to supply example input parameters to make it easier for new users to get started.<p>
        <p>You must provide admin passkey to be able to do this.</p>
        <p>Note: you must add the actual program files to the server from the lab computers. This form is merely to register that program in our API server.</p>
        <p>For futher documentation refer to <router-link to="/guide" exact>Deveolper's Guide</router-link>.</p>
        <h2>How do I change admin password?</h2>
        <p>Unfortunately, password reset through emails isn't implemented. So, in order to change the admin password, you need to generate a hash of the new password and store it into config.js file inside of biomall-express.</p>
        <p>You can use this <a href="https://passwordhashing.com/BCrypt/">website</a> to generate new hash.</p>
        <p>Storing password in plain text is a really bad idea, so the app expects a hashed value in the config file. Plain text password won't work because the backend compares the hashed value.</p> 
      </article>
      <article class="paper" v-if="activeGuide==1">
        <div v-html="projGuide"></div>
      </article>
      <article class="paper" v-if="activeGuide==2">
        <div v-html="vueGuide"></div>
      </article>
      <article class="paper" v-if="activeGuide==3">
        <div v-html="expGuide"></div>
      </article>
    </template>
  </div>
</transition>
</template>
<script>
import marked from 'marked';
import vueReadme from '@/../README.md';
import expReadme from '@/../../biomall-express/README.md';
import projReadme from '@/../../README.md';
import hljs from "highlight.js"

import axios from 'axios';
export default {
	name: 'selectProgram',
	data () {
		return {
      msg: "Developer's Guide to BioMaLL Web Portal",
      numGuide: 4,
      activeGuide: 0,
	videoSources: ["/guides/admin.mp4", "/guides/proj.mp4", "/guides/frontend.mp4", "/guides/backend.mp4"],
      vueGuide: '',
      expGuide: '',
      projGuide: '',
      passkey: '',
      loggedIn: false,
      invalidPass: false
		}
	}, methods: {
    nextDoc() {
      this.activeGuide = this.activeGuide + 1;
      let activeLabel = document.querySelector("li.shown");
      if (this.activeGuide > (this.numGuide - 1)) {
        activeLabel.classList.remove("shown");
        document.querySelector(".docs li").classList.add("shown");
        this.activeGuide = 0;
      } else {
        activeLabel.classList.remove("shown");
        activeLabel.nextElementSibling.classList.add("shown");
      }
      this.$refs.videoRef.pause();
      this.$refs.videoRef.src=this.videoSources[this.activeGuide];
    },
    prevDoc() {
      this.activeGuide = this.activeGuide - 1;
      let activeLabel = document.querySelector("li.shown");
      if (this.activeGuide < 0) {
        activeLabel.classList.remove("shown");
        document.querySelector(".docs li:last-child").classList.add("shown");
        this.activeGuide = this.numGuide - 1;
      } else {
        activeLabel.classList.remove("shown");
        activeLabel.previousSibling.classList.add("shown");
      }
      this.$refs.videoRef.pause();
      this.$refs.videoRef.src=this.videoSources[this.activeGuide];
    },
    compileMarkdown() {
      marked.setOptions({
        highlight: code => hljs.highlightAuto(code).value,
      });
      this.vueGuide = marked(vueReadme);
      this.expGuide = marked(expReadme);
      this.projGuide = marked(projReadme);
    },
    getAdminAccess() {
      axios.post(process.env.VUE_APP_API_HOST +'/api/admin/', {pass: this.passkey})
        .then(res => {
          if(res.data.msg == 'go!')
            this.loggedIn = true;
          else
            this.invalidPass = true;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }, mounted() {
    this.compileMarkdown();
  }
}
</script>
<style>
pre {
  padding: var(--gap);
  background: #FDF6E3;
  overflow-x: auto;
}
#guide .paper h1 {
  display: none;
}
#video-cont {
	max-width: calc(100% - 2*var(--gap-huge));
  margin-bottom: var(--gap-huge);
}
article.paper {
  overflow: auto;
}
.docs {
  padding: 5px;
  background: var(--canvas-light);
  margin-bottom: var(--gap-huge);
  border-radius: 20px;
  box-shadow: 5px 5px var(--shadow);
}
.docs button {
  border-radius: 20px;
  width: 40px;
  line-height: 1;
}
.docs ul {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: center;
}
.docs ul li {
  display: none;
  line-height: 1;
  padding: var(--gap);
  text-transform: uppercase;
  font-weight: bold;
}
.docs ul li.shown {
  display: block;
}
.docs {
  display: grid;
  grid-template-columns: auto 1fr auto auto;
}
.login label {
  padding: var(--gap);
}
.login input {
  width: calc(100% - 24px);
}
.login form {
  width: 40%;
  float: right;
  position: relative;
}
</style>
